module.exports = __webpack_public_path__ + "static/sole-layer-1-06dc7cf92299c125cbc1105822963fdd.png";